// interfaces
import { ICollectionsMainBanner } from "../ICollectionsMain";

// assets
import ArrowDownIcon from "@/components/icons/ArrowDownIcon";

import styles from "@/assets/styles/containers/collections-main.module.scss";

const CollectionsMainBanner = ({ handleScrollDown }: ICollectionsMainBanner) => {
  return (
    <div
      className={styles["locl-collections-main__banner"]}
      data-testid="locl-collections-main-banner"
    >
      <div className={styles["locl-collections-main__banner__content"]}>
        <h1>
          <span className={styles["locl-collections-main__banner__title"]}>Curated</span>
          <br />
          <span className={styles["locl-collections-main__banner__title"]}>Collections</span>
        </h1>
        <h2 className={styles["locl-collections-main__banner__subtitle"]}>
          Browse our curated collections to find the perfect <br />
          location for your next brand activation
        </h2>
        <div
          className={styles["locl-collections-main__banner__button"]}
          onClick={handleScrollDown}
          data-testid="locl-collections-main-banner-button"
        >
          Explore collections <ArrowDownIcon />
        </div>
      </div>
      <div
        className={styles["locl-collections-main__banner__chevron"]}
        onClick={handleScrollDown}
        data-testid="locl-collections-main-banner-chevron"
      />
    </div>
  );
};

export default CollectionsMainBanner;
